if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const button = this.querySelector('button');
        if (button && !button.dataset.showMoreBound) {
          button.dataset.showMoreBound = 'true';
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.expandShowMore(event.currentTarget);
          });
        }

        const details = this.closest('details');
        if (details && !details.dataset.showMoreFacetToggleBound) {
          details.dataset.showMoreFacetToggleBound = 'true';
          details.addEventListener('toggle', () => {
            if (details.open) return;
            details.querySelectorAll('show-more-button').forEach((el) => {
              if (typeof el.resetCollapsedState === 'function') {
                el.resetCollapsedState();
              }
            });
          });
        }
      }

      resetCollapsedState() {
        const container = this.closest('.parent-display') || this.closest('.mobile-facets__submenu');
        if (!container) return;
        container.querySelectorAll('.show-more-item').forEach((item) => item.classList.add('hidden'));
        this.querySelector('.label-show-more')?.classList.remove('hidden');
        this.querySelector('.label-show-less')?.classList.add('hidden');
      }

      expandShowMore(trigger) {
        const container = trigger.closest('.parent-display') || trigger.closest('.mobile-facets__submenu');
        if (!container) return;

        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        container.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));

        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }

        const nextElementToFocus = container.querySelector('.show-more-item');
        if (
          nextElementToFocus &&
          !nextElementToFocus.classList.contains('hidden') &&
          nextElementToFocus.querySelector('input')
        ) {
          nextElementToFocus.querySelector('input').focus();
        }
      }
    }
  );
}
